@let icon = $icon();
<button class="w-full cursor-pointer flex items-center" [style.gap]="$gap() | cssValue" (click)="toggleOpen()">
  @if (icon !== null) {
  <app-icon
    [icon]="icon"
    [color]="$iconColor()"
    [size]="$iconSize()"
    [scale]="$iconScale()"
    [rotation]="$iconRotation()"
    [viewBoxAdjustmentX]="$iconViewBoxAdjustmentX()"
    [viewBoxAdjustmentY]="$iconViewBoxAdjustmentY()"
  />
  }
  @if ($text() !== null) {
  <p
    [class]="'relative ' + ($textWrap() ? '' : 'whitespace-nowrap')" 
    [style.fontSize]="$textFontSize()"
    [style.fontWeight]="$textWeight()"
    [style.top]="$textTop()"
    [style.right]="$textRight()"
    [style.bottom]="$textBottom()"
    [style.left]="$textLeft()"
    [style.color]="'var(' + $textColor() + ')'"> {{ $text() }} </p>
  }
  <span class="line"></span>
  <app-icon icon="chevron-right" color="--secondary" [rotation]="!$open() ? 0 : 90" [rotationDelay]="100" />
</button>
